<template>
  <div class="pa-6">
    <!-- Breadcrumb and back button -->
    <v-row class="align-center bread-row">
      <v-col cols="12" md="10">
        <Breadcrump :crumbs="crumbs" />
      </v-col>
      <v-col cols="12" md="2" class="d-flex justify-end">
        <v-btn @click="$router.go(-1)" fab small dark color="#1976d2">
          <v-icon dark>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <!-- Filters -->
    <v-card class="pa-4 elevation-2 mb-4">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="selectedComplexId"
              :items="complexes"
              item-value="id"
              item-text="text"
              label="مجموعه"
              :search-input.sync="searchComplex"
              outlined
              dense
              hide-details
              hide-selected
              no-data-text="موردی یافت نشد"
              @change="onComplexChange"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="selectedSubComplexId"
              :items="subComplexes"
              item-value="id"
              item-text="text"
              label="زیر مجموعه"
              :search-input.sync="searchSubComplex"
              outlined
              dense
              hide-details
              hide-selected
              no-data-text="موردی یافت نشد"
              @change="onSubComplexChange"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="selectedDeviceId"
              :items="devices"
              item-value="id"
              item-text="text"
              label="دستگاه"
              :search-input.sync="searchDevice"
              outlined
              dense
              hide-details
              hide-selected
              no-data-text="موردی یافت نشد"
            ></v-autocomplete>
          </v-col> </v-row
        ><v-row class="align-center calendar-row">
          <v-col cols="12" md="3">
            <div class="calendar-wrapper">
              <p class="calendar-label">از:</p>
              <date-picker
                simple
                editable
                required
                v-model="from"
                placeholder="انتخاب تاریخ"
              />
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <div class="calendar-wrapper">
              <p class="calendar-label">تا:</p>
              <date-picker
                simple
                editable
                required
                v-model="to"
                placeholder="انتخاب تاریخ"
              />
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn
              :loading="excelLoading"
              color="green darken-1"
              class="white--text"
              @click="exportExcel"
            >
              <v-icon left>mdi-file-excel</v-icon>
              دریافت اکسل
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import moment from "moment-jalaali";
import request from "@/utils/request";
import Breadcrump from "@/components/common/Breadcrump.vue";

export default {
  name: "DeviceUsageExcel",
  components: { Breadcrump },
  data() {
    return {
      crumbs: [
        { text: "خانه", disabled: false, href: "/" },
        { text: "خروجی اکسل استفاده از دستگاه", disabled: true }
      ],
      complexes: [],
      subComplexes: [],
      devices: [],
      from: null,
      to: null,
      selectedComplexId: null,
      selectedSubComplexId: null,
      selectedDeviceId: null,
      searchComplex: null,
      searchSubComplex: null,
      searchDevice: null,
      valid: true,
      excelLoading: false
    };
  },

  created() {
    this.getComplexes();
  },

  methods: {
    async getComplexes() {
      try {
        const res = await request.get("/publicData/main-complexes");
        this.complexes = res.data.result || [];
        this.complexes.unshift({ id: null, text: "انتخاب..." });
      } catch {
        this.complexes = [{ id: null, text: "انتخاب..." }];
      }
    },

    async getSubComplexes(complexId) {
      if (!complexId) {
        this.subComplexes = [{ id: null, text: "انتخاب..." }];
        return;
      }
      try {
        const res = await request.get(`/publicData/sub-complexes/${complexId}`);
        this.subComplexes = res.data.result || [];
        this.subComplexes.unshift({ id: null, text: "انتخاب..." });
      } catch {
        this.subComplexes = [{ id: null, text: "انتخاب..." }];
      }
    },

    async getDevices(complexId) {
      if (!complexId) {
        this.devices = [{ id: null, text: "انتخاب..." }];
        return;
      }
      try {
        const res = await request.get(
          `/publicData/main-complexes-devices/${complexId}`
        );
        this.devices = res.data.result || [];
        this.devices.unshift({ id: null, text: "انتخاب..." });
      } catch {
        this.devices = [{ id: null, text: "انتخاب..." }];
      }
    },

    onComplexChange() {
      this.selectedSubComplexId = null;
      this.selectedDeviceId = null;
      this.subComplexes = [{ id: null, text: "انتخاب..." }];
      this.devices = [{ id: null, text: "انتخاب..." }];
      if (this.selectedComplexId) {
        this.getSubComplexes(this.selectedComplexId);
        this.getDevices(this.selectedComplexId);
      }
    },

    onSubComplexChange() {
      this.selectedDeviceId = null;
    },

    async exportExcel() {
      if (!this.selectedComplexId) {
        alert("لطفاً یک مجموعه انتخاب کنید.");
        return;
      }
      if (!this.from) {
        alert("لطفاً تاریخ شروع را انتخاب کنید.");
        return;
      }
      if (!this.to) {
        alert("لطفاً تاریخ پایان را انتخاب کنید.");
        return;
      }

      const from = moment(this.from, "jYYYY/jMM/jDD").format("YYYY-MM-DD");
      const to = moment(this.to, "jYYYY/jMM/jDD").format("YYYY-MM-DD");

      const params = {
        From: from,
        To: to
      };
      if (this.selectedDeviceId) params.DeviceId = this.selectedDeviceId;
      else if (this.selectedComplexId)
        params.ComplexId = this.selectedComplexId;

      this.excelLoading = true;
      try {
        const res = await request.get("/DeviceManagement/excel-device-usage", {
          params,
          responseType: "blob"
        });

        if (!res.data || res.data.size === 0) {
          alert("داده‌ای برای دانلود وجود ندارد.");
          return;
        }

        const blob = new Blob([res.data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `DeviceUsageReport_${moment().format(
          "jYYYYjMMjDD_HHmmss"
        )}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch {
        alert("خطا در دریافت فایل اکسل.");
      } finally {
        this.excelLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.IranSans {
  font-family: "IranSans", sans-serif !important;
}
.pa-6 {
  padding: 4px !important;
  min-height: 100vh;
}
.bread-row {
  margin-bottom: 4px !important;
  margin-top: -8px !important;
}
.v-card {
  border-radius: 16px !important;
}

.calendar-row {
  margin-top: 8px !important;
  margin-bottom: 24px;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.calendar-wrapper {
  display: flex;
  flex-direction: column;
}

.calendar-label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #333;
}
</style>
